//Types
export const Types = {
    CREATE_CHANGE_REQUEST: "CREATE_CHANGE_REQUEST",
    UPDATE_CHANGE_REQUEST: "UPDATE_CHANGE_REQUEST",
    GET_CHANGE_REQUEST: "GET_CHANGE_REQUEST",
    GET_CHANGE_REQUESTS: "GET_CHANGE_REQUESTS",
    GIVE_CHANGE_REQUEST: "GIVE_CHANGE_REQUEST",
    DENY_CHANGE_REQUEST: "DENY_CHANGE_REQUEST",
    REMOVE_CHANGE_REQUEST: "REMOVE_CHANGE_REQUEST",
    SET_LOADING: "SET_LOADING_CHANGE_REQUEST",
}

//Reducer
const initialState = {
    changeRequests: null,
    changeRequest: null,
    loading: false,
}

const ChangeRequest = (state = initialState, action) => {
    switch(action.type) {
        case Types.CREATE_CHANGE_REQUEST:
            return {
                ...state,
                changeRequests: action.payload,
                loading: false,
            }

        case Types.UPDATE_CHANGE_REQUEST:
            return {
                ...state,
                changeRequests: action.payload,
                loading: false,
            }

        case Types.GET_CHANGE_REQUEST:
            return {
                ...state,
                changeRequest: action.payload,
                loading: false,
            }

        case Types.GET_CHANGE_REQUESTS:
            return {
                ...state,
                changeRequests: action.payload,
                loading: false
            }

        case Types.GIVE_CHANGE_REQUEST:
            return {
                ...state,
                ...(action.payload? {changeRequests: action.payload} : {}),
                loading: false,
            }

        case Types.DENY_CHANGE_REQUEST:
            return {
                ...state,
                changeRequests: action.payload,
                loading: false,
            }

        case Types.REMOVE_CHANGE_REQUEST:
            return {
                ...state,
                changeRequests: action.payload,
                loading: false,
            }

        case Types.SET_LOADING:
            return {
                ...state,
                loading: true
            }

        default:
            return state;
    }
}

export default ChangeRequest;
